// Firebase web configuration.
// Fill these in the frontend/.env file (values come from your Firebase Console
// -> Project Settings -> General -> "Your apps" -> Web app -> Config).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// VAPID key from Firebase Console -> Project Settings -> Cloud Messaging.
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export function isFirebaseConfigured() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.messagingSenderId && VAPID_KEY);
}

export default firebaseConfig;